import React, { Dispatch, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, Col, Collapse, Input, Row } from 'antd';
import mask, { maskUndInt } from '../../../../utils/mask';
import { ApplicationState } from '../../../../store';
import TitlePage from '../../../../components/TitlePage';
import { Redirect } from 'react-router-dom';
import ModalEndereco from '../Modal/ModalEndereco';
import ModalTransportadora from '../Modal/ModalTransportadora';
import { loadSolicitacaoRequest } from '../../../../store/ducks/solicitacaoRetorno/actions';
import { loadRequest } from '../../../../store/ducks/agrupamento/actions';
import { Action } from 'typesafe-actions';
import {
  ArrowLeftOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import {
  Container,
  ContainerLayout,
  Div,
  Footer,
  Line,
  NameStrong,
  NumericColor,
  Payer,
  StylePagador,
  Total,
  TotalUnit,
  Value,
  Divider,
  CodeControl,
  NameTransport,
  TilteEndTransp,
  BR,
  QtdSpacement,
  TooltipIcon,
} from './styles';

const ConfirmacaoRetorno: React.FC = () => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const { Panel } = Collapse;

  const estoque = useSelector((state: ApplicationState) => state.EstoqueCart);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo?.codCdd);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const loadingSolicitarRetorno = useSelector(
    (state: ApplicationState) => state.SolicitacaoRetorno.loading
  );
  const depositantes = useSelector((state: ApplicationState) => state.Agrupamentos.data);
  const [observacao, setObservacao] = useState<string>('');
  const [agrupamento, setAgrupamento] = useState<boolean>(false);
  const [redirect, setRedirect] = useState<string>('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [father, setFather] = useState<any>();
  const [qtdelementos, setQtdelementos] = useState<any>();

  useEffect(() => {
    dispatch(loadRequest(inscricaoAtiva));
    if (qtdelementos === 0) setRedirect('/dashboard/estoque');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inscricaoAtiva]);

  useEffect(() => {
    depositantes?.map((depositante: any) => {
      return setAgrupamento(depositante.solicIndividual);
    });
  }, [depositantes]);

  const qtd = estoque?.cart.reduce(
    (acc, item) => acc + item.quantidade! * item.qtdPadraoFracionado,
    0
  );

  const handleOk = () => {
    const solicitacoes = groups.map((soli, index: number) => {
      return {
        sequencia: index + 1,
        inscricaoEstadual: soli.data[0].codParceiro,
        enderecoEntrega: { 0: soli.data[0].endereco },
        observacao,
        codTransportadora: soli.data[0].codTransportadora,
        clienteRetira: soli.data[0].clienteRetira,
        itens: soli.data.map((itens: any) => {
          return {
            codPagador: itens?.codPagador,
            numContrato: itens?.numcontrato,
            quantidade: itens?.quantidade * itens?.qtdPadraoFracionado,
            controle: itens?.controle,
            codProduto: itens?.codProduto,
            nuNota: itens?.nuNota,
            nuCobertura: itens?.nuCobertura

          };
        }),
      };
    });

    dispatch(loadSolicitacaoRequest(cddAtivo, solicitacoes));
  };

  var group_to_values = estoque.cart.reduce(function (obj: any, item) {
    const modoAgrupamento = agrupamento ? item.numNota : item.codParceiro;
    obj[modoAgrupamento] = obj[modoAgrupamento] || [];
    obj[modoAgrupamento].push({
      numNota: item.numNota,
      nuNota: item.nuNota,
      nuCobertura: item?.nuCobertura,
      descricaoProduto: item.descricaoProduto,
      parceiros: item.parceiros,
      quantidade: item.quantidade,
      qtdPadraoFracionado: item.qtdPadraoFracionado,
      reservado: item.reservado,
      siglaUnidade: item.siglaUnidade,
      nomePagador: item.nomePagador,
      controle: item.controle,
      nomeParceiro: item.nomeParceiro,
      endereco: item.endereco,
      codProduto: item.codProduto,
      codParceiro: item.codParceiro,
      cnpjCpf: item.cnpjCpf,
      inscricaoEstadual: item.inscricaoEstadual,
      codPagador: item.codPagador,
      codTransportadora: item.codTransportadora,
      nomeTranasportadora: item.nomeTranasportadora,
      clienteRetira: item.clienteRetira,
      cnpjCpfPagador: item.cnpjCpfPagador,
      inscricaoPagador: item.inscricaoPagador,
      numcontrato: item.numcontrato,
    });
    return obj;
  }, {});


  var groups = Object.keys(group_to_values).map(function (key) {
    return { codParceiro: key, data: group_to_values[key] };
  });

  var siglaUnidade = estoque.cart.map((SGL) => SGL.siglaUnidade);

  const qtdBtnConfirm = groups.length;

  useEffect(() => {
    const el1 = document.querySelectorAll('#clock');
    setQtdelementos(el1.length);
  }, [groups]);

  var group_values2 = estoque.cart.reduce(function (objT: any, itemParc: any) {
    objT[itemParc.codPagador] = objT[itemParc.codPagador] || [];
    objT[itemParc.codPagador].push({
      codPagador: itemParc.codPagador,
    });
    return objT;
  }, {});

  var groups2 = Object.keys(group_values2).map(function (key2) {
    return { codPagador: key2, data: group_values2[key2] };
  });

  const alertParc = groups.map((parcSele) => parcSele.codParceiro);
  const alertePag = groups2.map((pagSele) => pagSele.codPagador);

  return (
    <>
      <ContainerLayout>
        <TitlePage>
          <Row gutter={24} style={{ width: '100%' }}>
            <Col md={2} sm={24} xs={24}>
              <Button
                type="dashed"
                icon={<ArrowLeftOutlined />}
                onClick={() => {
                  setRedirect('/dashboard/estoque');
                }}
              >
                Voltar
              </Button>
            </Col>
            <Col md={4} sm={24} xs={24}>
              Confirmação de retorno
            </Col>
          </Row>
        </TitlePage>
        <Row gutter={24}>
          <Col md={24} sm={24} xs={24}>
            <Container>
              {alertParc.length > 1 ? (
                <Alert
                  message={<span style={{ color: '#FF4D4F', fontWeight: 500 }}>ATENÇÃO!</span>}
                  description={
                    <span style={{ color: '#FF4D4F', fontSize: '16px', fontWeight: 500 }}>
                      {' '}
                      Você está solicitando o retorno de{' '}
                      <span style={{ color: '#FF4D4F', fontSize: '18px', fontWeight: 900 }}>
                        {agrupamento ? 'notas' : 'depositantes'} diferentes.
                      </span>{' '}
                      Por este motivo essa solicitação será dividida em pedidos distintos. Isso irá
                      gerar uma NF-e para cada pedido.{' '}
                    </span>
                  }
                  type="error"
                  icon={<WarningOutlined style={{ color: '#f3080c', fontSize: '50px' }} />}
                  showIcon
                  closable
                  style={{ marginBottom: 16 }}
                />
              ) : alertePag.length > 1 ? (
                <Alert
                  message={<span style={{ color: '#FF4D4F' }}>ATENÇÃO!</span>}
                  description={
                    <span style={{ color: '#FF4D4F', fontSize: '16px' }}>
                      Você está solicitando o retorno de{' '}
                      <span style={{ color: '#FF4D4F', fontSize: '18px', fontWeight: 900 }}>
                        contratos diferentes.
                      </span>{' '}
                      Por este motivo essa solicitação será dividida em pedidos distintos. Isso irá
                      gerar uma NF-e para cada pedido.
                    </span>
                  }
                  type="error"
                  icon={<WarningOutlined style={{ color: '#f3080c', fontSize: '50px' }} />}
                  showIcon
                  closable
                  style={{ marginBottom: 16 }}
                />
              ) : (
                ''
              )}

              {groups.map((item, i) => (
                <Collapse
                  defaultActiveKey={item.codParceiro[0]}
                  style={{
                    marginBottom: '20px',
                  }}
                >
                  <Panel
                    header={
                      <StylePagador>
                        <NumericColor>
                          {i - 10 ? `#0${i + 1} ` : `#${i + 1} `}
                          <NameStrong>{`${item.data[0].codParceiro} - ${item.data[0].nomeParceiro}`}</NameStrong>
                          <p>CNPJ/CPF: {mask('cpfCnpj', item.data[0].cnpjCpf)}</p>
                          <p>Inscrição estadual: {item.data[0].inscricaoEstadual}</p>
                          {agrupamento && <p>NF-e: {item.data[0].numNota}</p>}
                        </NumericColor>
                        <Value>
                          Total:
                          <QtdSpacement>
                            {` ${maskUndInt(
                              item.data.reduce(function (acc: any, val: any) {
                                return acc + val.quantidade * val.qtdPadraoFracionado;
                              }, 0)
                            )} Kg/L `}
                          </QtdSpacement>
                          {(item.data[0].endereco?.length && item.data[0].codTransportadora) ||
                            item.data[0].clienteRetira ? (
                            <CheckCircleOutlined
                              id="clock"
                              style={{
                                fontSize: 28,
                                color: '#389E0D',
                                position: 'relative',
                                top: '3px',
                              }}
                            />
                          ) : (
                            <ClockCircleOutlined
                              style={{
                                fontSize: 28,
                                color: '#FA8C16',
                                position: 'relative',
                                top: '3px',
                              }}
                            />
                          )}
                        </Value>
                      </StylePagador>
                    }
                    key={item.codParceiro[i]}
                  >
                    <Container>
                      <Row gutter={24}>
                        <Col md={11} sm={24} xs={24}>
                          <h6>Pagador</h6>
                          {item.data.map((pagador: any) => (
                            <Payer>
                              {item.codParceiro[i] !== 'N' && (
                                <>
                                  <strong>{` ${pagador.nomePagador}`}</strong>
                                  <NumericColor>
                                    <p>{`Inscrição estadual: ${pagador.inscricaoPagador}`}</p>
                                    <p>Contrato: {pagador.numcontrato}</p>
                                  </NumericColor>
                                </>
                              )}
                            </Payer>
                          ))}
                          <BR />
                          {
                            <ModalEndereco
                              codProduto={item.data[0].codProduto}
                              codParceiro={item.data[0].codParceiro}
                              controle={item.data[0].controle}
                              endereco={item.data[0].endereco}
                            />
                          }
                          <Divider />
                          {item.data[0].nomeTranasportadora ? (
                            <TilteEndTransp>Transportadora: </TilteEndTransp>
                          ) : (
                            ''
                          )}
                          <NameTransport>{item.data[0].nomeTranasportadora}</NameTransport>
                          <ModalTransportadora
                            setProps={setFather}
                            codParceiro={item.data[0].codParceiro}
                            codProduto={item.data[0].codProduto}
                            nomeTransportadora={item.data[0].nomeTranasportadora}
                            numNota={item.data[0].numNota}
                          />
                          <h6>Observação:</h6>
                          <Input.TextArea
                            style={{ width: '100%', height: '100px', resize: 'none' }}
                            placeholder="Digite aqui suas observações"
                            onChange={(e) => setObservacao(e.target.value)}
                          />
                        </Col>

                        <Col md={12} sm={24} xs={24}>
                          <h6>Ite{item.data.length > 1 ? 'ns' : 'm'}</h6>
                          {Array.from(new Set(siglaUnidade)).map((itemsiglaUnidade) => {
                            var cont = 0;
                            return (
                              <>
                                {item.data.map((data: any) =>
                                  data.siglaUnidade === itemsiglaUnidade ? (
                                    <>
                                      <div style={{ fontWeight: 700 }}>Nota: {data.numNota}</div>

                                      <CodeControl>
                                        <div>Lote: {data.controle}</div>
                                        <Value>
                                          <TooltipIcon
                                            placement="topRight"
                                            title={`
                                            ${maskUndInt(data.quantidade)}
                                            UN
                                            ${' x ' +
                                              data.qtdPadraoFracionado +
                                              ' ' +
                                              data.siglaUnidade +
                                              ' = ' +
                                              maskUndInt(
                                                data.quantidade * data.qtdPadraoFracionado
                                              ) +
                                              ' ' +
                                              data.siglaUnidade
                                              }`}
                                          >
                                            {maskUndInt(data.quantidade * data.qtdPadraoFracionado)}
                                            {' ' + data.siglaUnidade}
                                          </TooltipIcon>
                                          <span style={{ display: 'none' }}>
                                            {(cont += data.quantidade * data.qtdPadraoFracionado)}
                                          </span>
                                        </Value>
                                      </CodeControl>
                                      <Div
                                        style={{
                                          borderBottom: '1px solid #d9d9d9',
                                          paddingBottom: '16px',
                                        }}
                                      >
                                        {data.descricaoProduto + ' '}
                                      </Div>
                                    </>
                                  ) : (
                                    ''
                                  )
                                )}
                                {cont > 0 ? (
                                  <TotalUnit style={{ fontWeight: 'bold' }}>
                                    <span>Total {itemsiglaUnidade}: </span>
                                    <span>{maskUndInt(cont) + ' ' + itemsiglaUnidade}</span>
                                  </TotalUnit>
                                ) : (
                                  ''
                                )}
                              </>
                            );
                          })}
                        </Col>
                      </Row>
                    </Container>
                  </Panel>
                </Collapse>
              ))}
              <Line />
              <Total>
                <Button
                  disabled={qtdBtnConfirm === qtdelementos && qtdelementos > 0 ? false : true}
                  loading={loadingSolicitarRetorno}
                  type="primary"
                  onClick={handleOk}
                  size="middle"
                >
                  Confirmar
                </Button>
                <Footer>
                  TOTAL
                  {` ${maskUndInt(qtd)} Kg/L`}
                </Footer>
              </Total>
            </Container>
          </Col>
        </Row>
        {redirect && <Redirect to={{ pathname: redirect }} />}
      </ContainerLayout>
    </>
  );
};

export default ConfirmacaoRetorno;
